import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getRevenueRecognation(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createRevenueRecognation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/revenue-recognation" + pathname, body);
}

export async function updateRevenueRecognation(
  pathname,
  queryParams,
  body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/revenue-recognation" + pathname + queryParams, body);
}

export async function verifyRevenueRecognation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/revenue-recognation" + pathname, body);
}

export async function deleteRevenueRecognation(
  pathname,
  queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/revenue-recognation" + pathname + queryParams);
}
